import React, { useRef, useState } from "react";
import { Link } from "react-router-dom";
import { getAllCountries } from "../data/countries";
import { getUsStates } from "../data/us_states";
import "../assets/Home.css";
import ScheduleDemo from "../components/ScheduleDemo";

function ContactUs() {
  let countries = getAllCountries();
  let usStates = getUsStates();
  let [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const form = useRef();
  const submitSuccess = useRef();
  const [successMsg, setSuccessMsg] = useState("");
  const submitFailed = useRef();
  const [errMsg, setErrMsg] = useState("");
  const [displayState, setDisplayState] = useState(false);
  const [isFormValid, setFormValid] = useState(false);

  const [mailerState, setMailerState] = useState({
    form: "message_form",
    firstName: "",
    lastName: "",
    schoolDistrict: "",
    country: "",
    state: "",
    email: "",
    phone: "",
  });

  const [formErrors, setFormErrors] = useState({
    form: "message_form",
    firstName: "",
    lastName: "",
    schoolDistrict: "",
    country: "",
    state: "",
    email: "",
    phone: "",
    message: "",
  });

  // function handleStateChange(e) {
  //     const { name, value } = e.target;
  //     setMailerState({ ...mailerState, [name]: value });

  //     if (name == 'country' && value == 'United States of America') {
  //         setDisplayState(true);
  //     } else if (name == 'country' && value != 'United States of America')  {
  //         setDisplayState(false);
  //     }
  // } // end of handleStateChange

  // const submitEmail = async (e) => {
  //     e.preventDefault();
  //     setIsFormSubmitted(isFormSubmitted);
  //     const api_url = process.env.REACT_APP_SEND_EMAIL;

  //     //validate form before submitting
  //     let errors = {};
  //     mailerState.firstName = mailerState.firstName.trim();
  //     mailerState.lastName = mailerState.lastName.trim();
  //     mailerState.email = mailerState.email.trim();
  //     mailerState.phone = mailerState.phone.trim();

  //     if (!mailerState.firstName) {
  //         errors.firstName = "First Name is required";
  //         setFormValid(false);
  //     } else { setFormValid(true); }
  //     if (!mailerState.lastName) {
  //         errors.lastName = "Last Name is required";
  //         setFormValid(false);
  //     } else { setFormValid(true); }
  //     if (!mailerState.country) {
  //         errors.country = "Country is required";
  //         setFormValid(false);
  //     } else if (mailerState.country =='United States of America' && !mailerState.state) {
  //         errors.state = "State is required";
  //         setFormValid(false);
  //     } else if (mailerState.country !='United States of America' && !mailerState.state) {
  //         setFormValid(true);
  //     } else if (mailerState.country == 'United States of America' && mailerState.state) {
  //         setFormValid(true);
  //     }
  //     if (!mailerState.email) {
  //         errors.email = "Email is required";
  //         setFormValid(false);
  //     } else { setFormValid(true); }
  //     if (!mailerState.phone) {
  //         errors.phone = "Phone is required";
  //         setFormValid(false);
  //     } else if (mailerState.phone.length < 10) {
  //         errors.phone = 'Phone number must be 10 digits';
  //         setFormValid(false);
  //     } else { setFormValid(true); }
  //     if (!mailerState.message) {
  //         errors.message = "Message is required";
  //         setFormValid(false);
  //     } else if (mailerState.message.trim().length == 0) {
  //         errors.message = "Message is required";
  //         setFormValid(false);
  //     } else { setFormValid(true); }

  //     setFormErrors(errors);

  //     if (isFormValid) {
  //         const response = await fetch(api_url, {
  //             method: "POST",
  //             headers: {
  //             "Content-type": "application/json",
  //             },
  //             body: JSON.stringify({mailerState}),
  //         })
  //         .then((res) => res.json())
  //         .then((res) => {
  //             setMailerState({
  //                 form: "message_form",
  //                 firstName: "",
  //                 lastName: "",
  //                 schoolDistrict: "",
  //                 country: "",
  //                 state: "",
  //                 email: "",
  //                 phone: "",
  //                 message: ""
  //             });
  //             setIsFormSubmitted(!isFormSubmitted)
  //             submitSuccess.current.value = 'Thank you! We will be in touch soon.';
  //             setTimeout(function(){
  //                 window.location.reload(1);
  //             }, 5000);
  //         },
  //         (error) => {
  //         setIsFormSubmitted(!isFormSubmitted)
  //             submitFailed.current.value = 'Send Failed. Please try again later.'
  //             setTimeout(function(){
  //                 window.location.reload(1);
  //             }, 5000);
  //         });
  //         e.target.reset();
  //     }
  // }; // end of submitEmail

  function handleStateChange(e) {
    const { name, value } = e.target;
    setMailerState({ ...mailerState, [name]: value });

    if (name === "country" && value === "United States of America") {
      setDisplayState(true);
    } else if (name === "country" && value !== "United States of America") {
      setDisplayState(false);
    }
  }

  const submitEmail = async (e) => {
    e.preventDefault();
    setIsFormSubmitted(isFormSubmitted);
    const api_url = process.env.REACT_APP_SEND_EMAIL;

    let errors = {};
    mailerState.firstName = mailerState.firstName.trim();
    mailerState.lastName = mailerState.lastName.trim();
    mailerState.email = mailerState.email.trim();
    mailerState.phone = mailerState.phone.trim();

    if (!mailerState.firstName) {
      errors.firstName = "First Name is required";
      setFormValid(false);
    } else {
      setFormValid(true);
    }

    if (!mailerState.lastName) {
      errors.lastName = "Last Name is required";
      setFormValid(false);
    } else {
      setFormValid(true);
    }

    if (!mailerState.country) {
      errors.country = "Country is required";
      setFormValid(false);
    } else if (
      mailerState.country === "United States of America" &&
      !mailerState.state
    ) {
      errors.state = "State is required";
      setFormValid(false);
    } else if (
      mailerState.country !== "United States of America" &&
      !mailerState.state
    ) {
      setFormValid(true);
    } else if (
      mailerState.country === "United States of America" &&
      mailerState.state
    ) {
      setFormValid(true);
    }

    if (!mailerState.email) {
      errors.email = "Email is required";
      setFormValid(false);
    } else {
      setFormValid(true);
    }

    if (!mailerState.phone) {
      errors.phone = "Phone is required";
      setFormValid(false);
    } else if (mailerState.phone.length < 10) {
      errors.phone = "Phone number must be 10 digits";
      setFormValid(false);
    } else {
      setFormValid(true);
    }

    if (!mailerState.message) {
      errors.message = "Message is required";
      setFormValid(false);
    } else if (mailerState.message.trim().length === 0) {
      errors.message = "Message is required";
      setFormValid(false);
    } else {
      setFormValid(true);
    }

    setFormErrors(errors);

    if (isFormValid) {
      await fetch(api_url, {
        method: "POST",
        headers: {
          "Content-type": "application/json",
        },
        body: JSON.stringify({ mailerState }),
      })
        .then((res) => res.json())
        .then(
          () => {
            setMailerState({
              form: "message_form",
              firstName: "",
              lastName: "",
              schoolDistrict: "",
              country: "",
              state: "",
              email: "",
              phone: "",
              message: "",
            });
            setIsFormSubmitted(!isFormSubmitted);
            submitSuccess.current.value =
              "Thank you! We will be in touch soon.";
            setTimeout(() => {
              window.location.reload();
            }, 5000);
          },
          () => {
            setIsFormSubmitted(!isFormSubmitted);
            submitFailed.current.value = "Send Failed. Please try again later.";
            setTimeout(() => {
              window.location.reload();
            }, 5000);
          }
        );
      e.target.reset();
    }
  };

  return (
    <div>
      <div id="form">
        <div>
          <section>
            <div className="left-col">
              <div id="cta">
                <div>
                  <p className="bold">How can we help?</p>
                </div>
                <div className="cta-btns">
                  <ScheduleDemo />
                  <button className="btn_request_trial">
                    <Link to="/request_trial_form">Request 30 Day Trial</Link>
                  </button>
                </div>
              </div>
              <div>
                <div className="contactInfo">
                  <h3 className="compTitle">Contact Us</h3>
                  <div>
                    <p className="bold">PowerSchool Manager</p>
                    <p>Eric Lammers</p>
                  </div>
                  <div>
                    <p className="bold">Phone</p>
                    <p>(740) 389 - 4798 Ext. 1247</p>
                  </div>
                  <div>
                    <p className="bold">Fax</p>
                    <p>(740) 389 - 4517</p>
                  </div>
                  <div>
                    <p className="bold">Location</p>
                    <p>100 Executive Drive</p>
                    <p>Marion, Ohio 43302</p>
                  </div>
                </div>
              </div>
            </div>

            {isFormSubmitted ? (
              <div className="right-col">
                <div
                  style={{
                    borderRadius: "5px",
                    width: "100%",
                    height: "20em",
                    padding: "6em 1em",
                    backgroundColor: "white",
                    marginTop: "4em",
                  }}
                >
                  <input
                    style={{
                      width: "100%",
                      textAlign: "center",
                      border: "none",
                      fontSize: "1.4em",
                      backgroundColor: "transparent",
                    }}
                    id="successMsg"
                    ref={submitSuccess}
                    value={successMsg}
                    onChange={(e) => setSuccessMsg(e.target.value)}
                    disabled
                  ></input>
                  <input
                    style={{
                      width: "100%",
                      textAlign: "center",
                      border: "none",
                      fontSize: "1.4em",
                      backgroundColor: "transparent",
                      color: "#cc0000",
                    }}
                    id="successMsg"
                    ref={submitFailed}
                    value={errMsg}
                    onChange={(e) => setErrMsg(e.target.value)}
                    disabled
                  ></input>
                </div>
              </div>
            ) : (
              <div className="right-col">
                <h4>Send Us a Message</h4>
                <form id="contactform" ref={form} onSubmit={submitEmail}>
                  <div>
                    <label>
                      First Name<span className="required">*</span>
                    </label>
                    <input
                      onChange={handleStateChange}
                      name="firstName"
                      type="Text"
                      autoComplete="off"
                      value={mailerState.firstName}
                    />
                    {formErrors.firstName && (
                      <span className="errorMessage">
                        {formErrors.firstName}
                      </span>
                    )}
                  </div>
                  <div>
                    <label>
                      Last Name<span className="required">*</span>
                    </label>
                    <input
                      name="lastName"
                      type="Text"
                      autoComplete="off"
                      value={mailerState.lastName}
                      onChange={handleStateChange}
                    />
                    {formErrors.lastName && (
                      <span className="errorMessage">
                        {formErrors.lastName}
                      </span>
                    )}
                  </div>
                  <div>
                    <label>School District</label>
                    <input
                      name="schoolDistrict"
                      type="Text"
                      autoComplete="off"
                      value={mailerState.schoolDistrict}
                      onChange={handleStateChange}
                    />
                    {formErrors.schoolDistrict && (
                      <span className="errorMessage">
                        {formErrors.schoolDistrict}
                      </span>
                    )}
                  </div>
                  <div>
                    <label>
                      Work Email<span className="required">*</span>
                    </label>
                    <input
                      name="email"
                      type="Email"
                      autoComplete="off"
                      value={mailerState.email}
                      onChange={handleStateChange}
                    />
                    {formErrors.email && (
                      <span className="errorMessage">{formErrors.email}</span>
                    )}
                  </div>
                  <div>
                    <label>
                      Phone Number<span className="required">*</span>
                    </label>
                    <input
                      name="phone"
                      type="number"
                      autoComplete="off"
                      value={mailerState.phone}
                      onChange={handleStateChange}
                    />
                    {formErrors.phone && (
                      <span className="errorMessage">{formErrors.phone}</span>
                    )}
                  </div>
                  <div>
                    <label>
                      Country<span className="required">*</span>
                    </label>
                    <select
                      name="country"
                      value={mailerState.country}
                      onChange={handleStateChange}
                    >
                      <option value="">Select Country</option>
                      {countries.map((country) => (
                        <option key={country.id} value={country.name}>
                          {country.name}
                        </option>
                      ))}
                    </select>
                    {formErrors.country && (
                      <span className="errorMessage">{formErrors.country}</span>
                    )}
                  </div>
                  <div className={displayState ? "shoe" : "hide"}>
                    <label>
                      State<span className="required">*</span>
                    </label>
                    <select
                      name="state"
                      value={mailerState.state}
                      onChange={handleStateChange}
                    >
                      <option value="">Select State</option>
                      {usStates.map((usState) => (
                        <option key={usState.id} value={usState.name}>
                          {usState.name}
                        </option>
                      ))}
                    </select>
                    {formErrors.state && (
                      <span className="errorMessage">{formErrors.state}</span>
                    )}
                  </div>
                  <div>
                    <label>
                      Message<span className="required">*</span>
                    </label>
                    <textarea
                      name="message"
                      value={mailerState.message}
                      onChange={handleStateChange}
                      placeholder="Enter your message here"
                      autoComplete="off"
                    ></textarea>
                    {formErrors.message && (
                      <span className="errorMessage">{formErrors.message}</span>
                    )}
                  </div>
                  <div>
                    <button name="sendMessage">SEND MESSAGE</button>
                  </div>
                </form>
              </div>
            )}
          </section>
        </div>
      </div>
    </div>
  );
}

export default ContactUs;
